import React, { PureComponent, ReactNode } from "react";
import { CSSTransition } from "react-transition-group";
import SortableTbl from "react-sort-search-table";
import Loader from "react-loader";

import {
  clearSessionData,
  currentBaseUrl,
  currentUser,
} from "src/common/services";
import CustomNavComponent from "src/components/CustomNav/CustomNav.Component";
import {
  Container,
  MenuGrid,
  MenuGridItem,
} from "../../../Teachers/TeacherMenu.styles";

import {
  LearnersRow,
  GradientList,
  GradientListItem,
  PerceptionsItem,
} from "./QuickGlance.styles";

import courses from "../../../../assets/images/mainmenus/courses.png";
import pathways from "../../../../assets/images/mainmenus/pathways.png";
import withServices from "src/HOCs/withServices";

interface Props {
  history: any;
  services: any;
}
interface State {
  toLogin: boolean;
  assessments: [];
  cohorts: [];
  userType: "";
  top5: [];
  bottom5: [];
  median5: [];
  lowAlerts: [];
  moderateAlerts: [];
  criticalAlerts: [];
  loading: boolean;
  cohortsLoading: boolean;
  phaseLoading: boolean;
  alertsLoading: boolean;
  selectedCohort: any;
  selectedAssessment: any;
  selectedPhase: any;
  phaseLearners: [];
  loaded: boolean;
}

const targets = [
  {
    title: "Target Intervention Group A - Phase 1",
    color: "#3ee9f7",
    bg: courses,
    to: "/",
    phase: 1,
    description:
      "This is the group of learners identified to support in phase 1, these will typically be your higher alert learners",
  },
  {
    title: "Target Intervention Group B - Phase 2",
    color: "#f143fc",
    bg: pathways,
    to: "/",
    phase: 2,
    description:
      "This is the group of learners identified to support in phase 2",
  },
  {
    title: "Target Intervention Group C - Phase 3",
    color: "#9143fc",
    bg: courses,
    to: "/",
    phase: 3,
    description:
      "This is the group of learners identified to support in phase 3",
  },
];

class QuickGlance extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      toLogin: false,
      assessments: [],
      cohorts: [],
      userType: "",
      top5: [],
      bottom5: [],
      median5: [],
      lowAlerts: [],
      moderateAlerts: [],
      criticalAlerts: [],
      phaseLearners: [],
      loading: false,
      cohortsLoading: false,
      phaseLoading: false,
      alertsLoading: false,
      selectedCohort: null,
      selectedAssessment: null,
      selectedPhase: null,
      loaded: false,
    };

    this.onSelectUserType = this.onSelectUserType.bind(this);
    this.onSelectAssessment = this.onSelectAssessment.bind(this);
    this.onSelectAssessmentCohort = this.onSelectAssessmentCohort.bind(this);
  }

  public onLogout(arg) {
    clearSessionData();
    this.setState({ toLogin: true });
  }

  public onProfile = () => {
    this.props.history.push(`${currentBaseUrl()}profilepage`);
  };

  public onMenuItemClick = (path) => {
    if (path === "helpcenter") {
      window.open("https://myperformancelearning.com/help", "_blank");
      return;
    }
    this.props.history.push(path);
  };

  public customTD = (props) => {
    return (
      <td>
        {/*tslint:disable-next-line jsx-no-lambda*/}
        <button
          className="blue-button view-more-data"
          onClick={this.viewMoreData.bind(this, props.rowData.userid)}
        >
          View More
        </button>
      </td>
    );
  };
  public viewMoreData = (userid) => {
    const history: any = this.props.history;
    history.push(`${currentBaseUrl()}viewstudentdata/${userid}`);
  };

  public async onSelectUserType(e) {
    this.setState({ loading: true, loaded: false });

    const {
      services: { currentUserID, institutionsAPI },
    } = this.props;

    const userType = e.target.value;

    if (e.target.value === "") {
      return;
    }

    const res = await institutionsAPI.getInstitutionsAssessments(currentUserID);

    if (res.ok) {
      this.setState({
        loading: false,
        userType,
        assessments: res.data.assessments,
      });
    } else {
      // toast message
    }

    this.setState({ selectedCohort: null });
  }

  public async onSelectAssessment(e) {
    this.setState({ loading: true });
    const assessment = e.target.value;
    const {
      services: { currentUserID, institutionsAPI },
    } = this.props;
    // const {selectedAssessment} = this.state;

    const cohortsRes = await institutionsAPI.getCohortsList(
      currentUserID,
      assessment
    );

    if (cohortsRes.ok) {
      this.setState({
        loading: false,
        selectedAssessment: assessment,
        cohorts: cohortsRes.data.cohorts,
      });
    } else {
      // toast error
    }
  }

  public async onSelectAssessmentCohort(e) {
    this.setState({ loading: true });

    const { selectedAssessment, userType } = this.state;

    const {
      services: { currentUserID, institutionsAPI },
    } = this.props;

    const cohort = e.target.value;

    console.log(selectedAssessment + " vs " + userType + " vs " + cohort);

    const [quantileRes, alertsRes] = await Promise.all([
      institutionsAPI.fetchQuantileTop5(selectedAssessment, cohort, userType),
      institutionsAPI.getQuickGlanceAlerts(
        selectedAssessment,
        cohort,
        userType
      ),
    ]);

    if (quantileRes.ok) {
      this.setState({
        loading: false,
        loaded: true,
        top5: quantileRes.data.top,
        bottom5: quantileRes.data.bottom,
        median5: quantileRes.data.median,
        lowAlerts: alertsRes.data.top,
        moderateAlerts: alertsRes.data.median,
        criticalAlerts: alertsRes.data.bottom,
        selectedCohort: cohort,
      });
    } else {
      // toast error
    }
  }

  public async getPhaseIntervention(item) {
    console.log(item.phase);
    this.setState({ phaseLoading: true });

    const { selectedAssessment, selectedCohort, userType } = this.state;

    const res = await this.props.services.institutionsAPI.getPhaseIntervention(
      selectedAssessment,
      selectedCohort,
      userType,
      item.phase
    );

    if (res.ok) {
      this.setState({
        phaseLoading: false,
        selectedPhase: item.title,
        phaseLearners: res.data.users,
      });
    }
    console.log({ res });
  }

  public renderPickers = () => {
    const {
      assessments,
      cohorts,
      loading,
      userType,
      selectedAssessment,
      cohortsLoading,
      selectedCohort,
      phaseLoading,
      alertsLoading,
    } = this.state;

    return (
      <div className="sf-query-wrapper">
        <div className="sf-query">
          {/* usertype options */}
          <div className="show-picker step-2">
            <span>What shall we explore today &nbsp;</span>
            <span>
              <select
                className="custom-select sf-select"
                onChange={this.onSelectUserType}
                style={{ width: "250px" }}
                defaultValue={userType}
              >
                <option value=""> -- </option>
                <option
                  // selected={currentUserType === "students"}
                  value="2"
                >
                  Our Learners{" "}
                </option>
                <option
                  // selected={currentUserType === "teachers"}
                  value="1"
                >
                  Our Teachers{""}
                </option>
              </select>
            </span>
          </div>

          {/* assessment options */}
          <div
            className={`${
              !loading ? "show-picker step-3" : "hide-search-picker "
            }`}
          >
            <span>Choose an assessment to explore &nbsp; </span>
            <span>
              <select
                className="custom-select sf-select"
                onChange={this.onSelectAssessment}
                style={{ width: "250px" }}
              >
                <option> -- </option>
                {assessments.map((assessment: any) => (
                  <option
                    selected={assessment.id === +selectedAssessment}
                    key={assessment.id}
                    value={assessment.id}
                  >
                    {assessment.name}
                  </option>
                ))}
              </select>
            </span>
          </div>

          {/* Cohorts */}
          <div
            className={`${
              !cohortsLoading ? "show-picker step-3" : "hide-search-picker "
            }`}
          >
            <span>Choose a cohort &nbsp; </span>
            <span>
              <select
                className="custom-select sf-select"
                onChange={this.onSelectAssessmentCohort}
                style={{ width: "250px" }}
              >
                <option value=""> -- </option>
                {cohorts.map((cohort: any) => (
                  <option
                    selected={cohort.assessment === selectedCohort}
                    key={cohort.assessment}
                    value={cohort.assessment}
                  >
                    {cohort.assessment}
                  </option>
                ))}
              </select>
            </span>
          </div>
        </div>
      </div>
    );
  };

  public render(): ReactNode {
    const {
      top5,
      bottom5,
      median5,
      moderateAlerts,
      lowAlerts,
      criticalAlerts,
      phaseLoading,
      phaseLearners,
      selectedPhase,
      loading,
      loaded,
    } = this.state;

    return (
      <Container>
        <CustomNavComponent
          {...this.props}
          logoutParent={this.onLogout}
          profileParent={this.onProfile}
        />
        <h1
          style={{ marginBottom: "2em", fontSize: "40px" }}
          className="menu-heading"
        >
          Hey <span>{currentUser()}</span>
        </h1>
        {this.renderPickers()}
        {loaded ? (
          <>
            <LearnersRow margin="4em">
              <h2 className="row-heading">Your Learners</h2>

              <div className="learners-row">
                <GradientList>
                  <h3 className="list-title">Top 5 Learners</h3>
                  <p className="help-text help-small">
                    This list shows your highest-scoring learners
                  </p>
                  {!top5.length ? (
                    <p className="list-empty">No learners fit this category </p>
                  ) : (
                    <></>
                  )}
                  {top5.map((learner: any, i) => (
                    <GradientListItem
                      highlightColor={`rgba(170, 255, 29, ${
                        (9 + (5 - i + 1) * 15) / 100
                      })`}
                      key={`top5_${learner.username}_${i}`}
                    >
                      {" "}
                      {`${i + 1}. ${
                        !learner.first_name.length || !learner.last_name.length
                          ? learner.username
                          : `${learner.first_name} ${learner.last_name}`
                      }`}
                    </GradientListItem>
                  ))}
                </GradientList>

                <GradientList>
                  <h3 className="list-title">Focus Needed Here</h3>
                  <p className="help-text help-small">
                    This shows your lowest-scoring learners
                  </p>
                  {!bottom5.length ? (
                    <p className="list-empty">No learners fit this category </p>
                  ) : (
                    <></>
                  )}
                  {bottom5.map((learner: any, i) => (
                    <GradientListItem
                      highlightColor={`rgba(255, 11, 11, ${
                        (9 + (5 - i + 1) * 15) / 100
                      })`}
                      key={`top5_${learner}_${i}`}
                    >
                      {`${i + 1}. ${
                        !learner.first_name.length || !learner.last_name.length
                          ? learner.username
                          : `${learner.first_name} ${learner.last_name}`
                      }`}
                    </GradientListItem>
                  ))}
                </GradientList>

                <GradientList>
                  <h3 className="list-title">On the Radar</h3>
                  <p className="help-text help-small">
                    This shows your lowest-scoring moderate alert learners
                  </p>
                  {!median5.length ? (
                    <p className="list-empty">No learners fit this category </p>
                  ) : (
                    <></>
                  )}

                  {median5.map((learner: any, i) => (
                    <GradientListItem
                      highlightColor={`rgb(255, 122, 3, ${
                        (9 + (5 - i + 1) * 15) / 100
                      })`}
                      key={`top5_${learner}_${i}`}
                    >
                      {`${i + 1}. ${
                        !learner.first_name.length || !learner.last_name.length
                          ? learner.username
                          : `${learner.first_name} ${learner.last_name}`
                      }`}
                    </GradientListItem>
                  ))}
                </GradientList>
              </div>
            </LearnersRow>
            <LearnersRow margin="4em" backgroundColor="#000">
              <h2 className="row-heading">TARGET INTERVENTION</h2>

              <MenuGrid>
                {targets.map((item, i) => (
                  <MenuGridItem
                    highlightColor={item.color}
                    backgroundImage={item.bg}
                    key={`target_intervention_${i}_${item.title}`}
                  >
                    <div className="bg-holder" />

                    <div className="menu-item-content">
                      <div>
                        <h2 className="menu-item-name">{item.title}</h2>
                        <p className="menu-item-description">
                          {item.description}
                        </p>
                      </div>
                      <button
                        onClick={this.getPhaseIntervention.bind(this, item)}
                        className="menu-item-btn"
                      >
                        EXPLORE
                      </button>
                    </div>
                  </MenuGridItem>
                ))}
              </MenuGrid>
            </LearnersRow>
            {phaseLearners.length ? (
              <CSSTransition
                in={!phaseLoading}
                classNames="fade"
                timeout={3000}
              >
                <LearnersRow width="80%" backgroundColor="#000">
                  <h2 className="row-subheading">{selectedPhase}</h2>

                  {phaseLoading ? (
                    <Loader color="#acff24" loaded={!phaseLoading} />
                  ) : (
                    <div className="learners-row">
                      <SortableTbl
                        tblData={phaseLearners}
                        tHead={["Name", "Action"]}
                        dKey={["name", "viewmore"]}
                        customTd={[
                          {
                            custd: this.customTD,
                            keyItem: "viewmore",
                            sortable: false,
                          },
                        ]}
                        defaultCSS={false}
                      />
                    </div>
                  )}
                </LearnersRow>
              </CSSTransition>
            ) : (
                ""
            )}
            <LearnersRow>
              <h2 className="row-heading">Alerts</h2>

              <div className="learners-row">
                <GradientList>
                  <h3 className="list-title">Critical Severe Alerts</h3>
                  <p className="help-text help-small">
                    These are your five lowest-scoring Severe Alert learners
                  </p>
                  {!criticalAlerts.length ? (
                    <p className="list-empty">No learners fit this category </p>
                  ) : (
                    <></>
                  )}
                  {criticalAlerts.map((learner: any, i) => (
                    <GradientListItem
                      highlightColor={`rgba(255, 11, 11, ${
                        (9 + (5 - i + 1) * 15) / 100
                      })`}
                      key={`top5_${learner}_${i}`}
                      onClick={this.viewMoreData.bind(this, learner.userid)}
                    >
                      {" "}
                      {`${i + 1}. ${
                        !learner.first_name.length || !learner.last_name.length
                          ? learner.username
                          : `${learner.first_name} ${learner.last_name}`
                      }`}
                    </GradientListItem>
                  ))}
                </GradientList>

                <GradientList>
                  <h3 className="list-title">Managing Moderate Alerts</h3>
                  <p className="help-text help-small">
                    These are your five middle-scoring Moderate Alert learners
                  </p>
                  {!moderateAlerts.length ? (
                    <p className="list-empty">No learners fit this category </p>
                  ) : (
                    <></>
                  )}

                  {moderateAlerts.map((learner: any, i) => (
                    <GradientListItem
                      highlightColor={`rgba(255, 122, 3, ${
                        (9 + (5 - i + 1) * 15) / 100
                      })`}
                      key={`top5_${learner}_${i}`}
                    >
                      {`${i + 1}. ${
                        !learner.first_name.length || !learner.last_name.length
                          ? learner.username
                          : `${learner.first_name} ${learner.last_name}`
                      }`}
                    </GradientListItem>
                  ))}
                </GradientList>

                <GradientList>
                  <h3 className="list-title">Just About Low Alerts</h3>
                  <p className="help-text help-small">
                    These are your five lowest-scoring Low Alert learners
                  </p>

                  {!lowAlerts.length ? (
                    <p className="list-empty">No learners fit this category </p>
                  ) : (
                    <></>
                  )}

                  {lowAlerts.map((learner: any, i) => (
                    <GradientListItem
                      highlightColor={`rgb(255, 207, 77, ${
                        (9 + (5 - i + 1) * 15) / 100
                      })`}
                      key={`top5_${learner}_${i}`}
                    >
                      {`${i + 1}. ${
                        !learner.first_name.length || !learner.last_name.length
                          ? learner.username
                          : `${learner.first_name} ${learner.last_name}`
                      }`}
                    </GradientListItem>
                  ))}
                </GradientList>
              </div>
            </LearnersRow>
            <LearnersRow style={{ display: "none" }} backgroundColor="#000">
              <h2 className="row-heading">Perceptions</h2>

              <div className="learners-row">
                <PerceptionsItem color="#fff" bgColor="#ff0b0b">
                  <h3 className="perceptions-title">Improve this:</h3>
                  <div className="perceptions-button">
                    Perceptions towards institution
                  </div>
                </PerceptionsItem>
                <PerceptionsItem color="#fff" bgColor="#ff7a03">
                  <h3 className="perceptions-title">
                    Keep this on your radar:
                  </h3>
                  <div className="perceptions-button">
                    Sleep &amp; Tiredness
                  </div>
                </PerceptionsItem>
                <PerceptionsItem color="#000" bgColor="#acff24">
                  <h3 className="perceptions-title">Celebrate this:</h3>
                  <div className="perceptions-button">
                    Focus &amp; Motivation
                  </div>
                </PerceptionsItem>
              </div>
            </LearnersRow>{" "}
          </>
        ) : (
          ""
        )}
      </Container>
    );
  }
}

export default withServices(QuickGlance);



// WEBPACK FOOTER //
// ./src/pages/DataCenter/School/QuickGlance/QuickGlance.Component.tsx